import { UIParticipant, UIParticipantStatus } from '@azavista/participants/dist/event-app/multiregistration';
import { TRANSLATION_MAP, TranslationMapKey } from 'src/app/enums';

export const MULTI_REGISTRATION_ATTRIBUTE_NAMES = {
    ticket_type_id: 'ticket_type_id',
    classNamePrefixSubParticipant: 'multi-registration__sub-participant-',
    main_participant_assigned_field_id: 'main_participant_assigned',
    draftParticipantId: 'draftParticipantId',
    subParticipantIdAttrName: 'sub-participant-id',
    assignMainParticipantClassName: 'multi-registration__header__assign-main-participant',
    tableColumnStatusText: 'statusText'
} as const;

export const UI_PARTICIPANT_STATUS_TRANSLATION = {
    [UIParticipantStatus.CANCELLED]: TRANSLATION_MAP.CANCELLED,
    [UIParticipantStatus.CONFIRMED]: TRANSLATION_MAP.CONFIRMED,
    [UIParticipantStatus.PENDING_ASSIGNMENT]: TRANSLATION_MAP.PENDING_ASSIGNMENT,
    [UIParticipantStatus.PENDING_CONFIRMATION]: TRANSLATION_MAP.PENDING_CONFIRMATION,
    [UIParticipantStatus.SCANNED]: TRANSLATION_MAP.SCANNED
} satisfies Record<UIParticipantStatus, TranslationMapKey>;

export type TableRowObject = Pick<UIParticipant, 'id' | 'ticket_type_id'> &
    UIParticipant['participant_attributes'] & {
        ui_participant: UIParticipant,
        /** Translate text of UIParticipantStatus value */
        statusText: string;
    };

export type DraftNewSubParticipant = {
    [newDraft in (typeof MULTI_REGISTRATION_ATTRIBUTE_NAMES)['draftParticipantId']]?:
        | (Pick<
              UIParticipant,
              | 'ticket_options'
              | 'participant_attributes'
              | 'ticket_type_id'
              | 'status'
          > &
              Partial<UIParticipant>)
            & {
                id: typeof MULTI_REGISTRATION_ATTRIBUTE_NAMES['draftParticipantId']
            }
        | undefined;
};

export type DraftSubParticipantRecord = DraftNewSubParticipant & {
    [subParticipantId: string]: UIParticipant | undefined;
};
